import * as types from './mutation-types'
let defaultObject = () => ({
  data: {
  }
})

export default {
  [types.SET_MENU] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    state.menu = payload
  },
  [types.SET_MENUS] (state, payload) {
    state.menus = payload.data
    // state.pagination = payload.meta.pagination
  }
}
